// src/pages/SkillsArtSportPage.jsx
import React from 'react';
import NavBar from '../components/NavBar';
import './SkillsArtSportPage.css';
import headerImg from '../assets/sanat.jpg';

import d1 from '../assets/se1.jpeg';
import d2 from '../assets/se2.jpeg';
import d3 from '../assets/se3.jpeg';
import d4 from '../assets/se4.jpeg';
import d5 from '../assets/se5.jpeg';

import y1 from '../assets/y1.jpg';
import y2 from '../assets/y2.jpeg';
import y3 from '../assets/y3.jpg';

import q1 from '../assets/q1.jpeg';
import q2 from '../assets/q2.jpeg';
import q3 from '../assets/q3.jpeg';
import q4 from '../assets/q4.jpeg';

import r1 from '../assets/r1.jpeg';
import r2 from '../assets/r2.jpeg';
import r3 from '../assets/r3.jpeg';
import r4 from '../assets/r4.jpeg';
import r5 from '../assets/r5.jpeg';
import r6 from '../assets/r6.jpeg';

import m1 from '../assets/m1.jpeg';
import m2 from '../assets/m2.jpeg';
import m3 from '../assets/m3.jpeg';
import m4 from '../assets/m4.jpeg';

import s1 from '../assets/s1.jpeg';
import s2 from '../assets/s2.jpeg';
import s3 from '../assets/s3.jpeg';
import s4 from '../assets/s4.jpeg';
import s5 from '../assets/s5.jpeg';
import s6 from '../assets/s6.jpeg';


import ma1 from '../assets/ma1.jpeg';
import ma2 from '../assets/ma2.jpeg';
import ma3 from '../assets/ma3.jpeg';
import ma4 from '../assets/ma4.jpeg';



import g1 from '../assets/g1.jpeg';
import g2 from '../assets/g2.jpeg';
import g3 from '../assets/g3.jpeg';
import g4 from '../assets/g4.jpeg';

import dr1 from '../assets/dr1.jpg';
import dr2 from '../assets/dr2.jpg';
import dr3 from '../assets/dr3.jpg';
import dr4 from '../assets/dr4.jpg';

export default function SkillsArtSportPage() {
  return (
    <>
      <NavBar />

      <section id="skills-art-sport-page" className="skills-art-sport-page">
        <div
          className="hero-bg"
          style={{ backgroundImage: `url(${headerImg})` }}
        >
          <div className="overlay" />
          <h1 className="hero-title">Atölyelerimiz</h1>
        </div>

        {/* Masal Atölyesi */}
        

      

        {/* Drama Atölyesi */}
        <div className="atolye-section">
          <h2>Drama Atölyesi</h2>
          <p>
            Drama atölyemiz, çocuklara yaratıcılıklarını keşfetme, kendilerini ifade etme ve iletişim
            becerilerini geliştirme fırsatı sunar. Rol oynama, hikâye anlatma, sahneleme gibi etkinlikler,
            çocukların kendilerini daha iyi tanımalarını, özgüvenlerini artırmalarını ve toplumda etkili
            iletişim kurmalarını sağlar.
          </p>
          <p>
            Drama atölyesinin yararları arasında olumlu iletişim becerisi kurma vardır. Drama, farklı olay ve
            durumlarla ilgili deneyim kazanmayı sağlar. Farklı özelliklere sahip kişilere saygı duymayı ve
            duygu ve düşünceleri sözel ve bedensel ifade edebilme becerilerini artırır.
          </p>

          <div className="images-grid">
            {[dr1, dr2, dr3, dr4].map((src, idx) => (
              <img key={idx} src={src} alt={`Seramik ${idx + 1}`} />
            ))}
          </div>
        </div>

        {/* Seramik Atölyesi */}
        <div className="atolye-section">
          <h2>Seramik Atölyesi</h2>
          <p>
            Seramik atölyemiz küçük ellerde büyük sanat eserlerinin doğmasına olanak sağlıyor. Seramik atölyesi
            yaratıcı ifadenin mükemmel bir yoludur. Kile şekil verilmesi, desenlerin oluşturulması ve renklerin
            seçimi, çocukların iç dünyasını ve sanatsal vizyonunu ifade etmesine olanak tanıyor. Öğrencilerimiz
            kendi yaratıcılıklarını katarak seramik kupa bardak, seramik vazo, seramik mumluk, seramik dekorasyon
            parçaları ortaya çıkarırlar.
          </p>
          <div className="images-grid">
            {[d1, d2, d3, d4, d5].map((src, idx) => (
              <img key={idx} src={src} alt={`Seramik ${idx + 1}`} />
            ))}
          </div>
        </div>


        {/* Geleneksel Çocuk Oyunları Atölyesi */}
        <div className="atolye-section">
          <h2>Geleneksel Çocuk Oyunları Atölyesi</h2>
          <p>
            Geleneksel Oyunlar Atölyesi ‘oyun’ kavramını dijital dünyanın esaretinden alıp arkadaşın, iletişimin,
            kahkahanın ve heyecanın içine çekmektedir. Oyunun amacı da tam olarak bu değil midir? Geleneksel çocuk oyunları
            çocuğu doğal ortama çekerek onların doğal bir çocukluk yaşamasına fırsat sunmaktadır. Geleneksel Oyunlar Atölyemizde
            çocukların paylaşmasına, sosyalleşmesine, kendini ifade etmesine ve tüm bunları yaparken gözlemlenmesine olanak
            sağlanmaktadır. Konuşmayı, yardımlaşmayı, birlik olmayı, empatiyi yaşayarak ve eğlenerek öğrenen çocuklar daha
            güçlü gelişmektedir. Bu gelişimler çocuğun bilişsel, duygusal olarak güçlenmesini sağlayarak öz yeterliliği
            artırmaktadır. Aynı zamanda çocuktaki benlik algısının da gelişmesini destekleyen geleneksel oyun ortamları
            çocukların ileride birçok farklı beceriye sahip olmasının da önünü açmaktadır. Çocuklarımızla oynadığımız oyunların
            başında herkesin bildiği ve oynamaktan keyif aldığı; “körebe”, “aç kapıyı bezirgan başı”, “birdirbir”,
            “kutu kut pense”, “yağ satarım bal satarım”, “yakan top”, “uzun eşek”, “köşe kapmaca”, “saklambaç”, “ip atlama”
            gibi oyunlar geliyor.
          </p>

          <div className="images-grid">
            {[g1, g2, g3, g4].map((src, idx) => (
              <img key={idx} src={src} alt={`Seramik ${idx + 1}`} />
            ))}
          </div>
        </div>



        {/* Yaşam Becerileri Atölyesi */}
        <div className="atolye-section">
          <h2>Yaşam Becerileri Atölyesi</h2>
          <p>
          Bu atölye öğrencilerimiz hayatımızı sürdürürken bir yandan yapmak zorunda olduğumuz faaliyetleri net bir 
          şekilde benimseme fırsatı yaratır. Elbette belirli bir yaşa kadar ihtiyaçlar ebeveynler tarafından karşılanacaktır  ancak kendini 
          bilmeye başlayan birey haline geldiğinde ütü yapmak, yemek yapmak, dikiş yapmak , çamaşır yıkamak olmazsa olmaz hale gelecektir. 
          Bu bağlamda atölyemizde öğrencilerimize yaşamlarını devam ettirirken gerekli olan temel becerileri öğretmek amaçlanmıştır.
          </p>
          <div className="images-grid">
            {[y1, y2, y3].map((src, idx) => (
              <img key={idx} src={src} alt={`Yaşam Becerileri ${idx + 1}`} />
            ))}
          </div>
        </div>

        {/* Yabancı Dil Atölyesi */}
        <div className="atolye-section">
          <h2>Yabancı Dil Atölyesi</h2>
          <p>
          Bu atölyelerde öğrencilerimize gramer gibi İngilizcenin yapısal özelliklerini öğretme veya ezberletme değil, öğrencilerin aktif ve akıcı bir şekilde İngilizceyi iletişim dili olarak kullanabilmelerini sağlamayı amaçlamaktayız. 
Okulumuzdaki yabancı dil atölyesinde verilen İngilizce eğitimi, çocukların kendine özgü gelişim ve öğrenme özellikleri göz önüne alınarak, onların yaş gruplarına göre oyun ve etkinliklerle ( görsel, işitsel ve yaparak-yaşayarak öğrenmeye dayanan oyun ve aktivitelerde ) yapılmaktadır.
Okulumuzdaki İngilizce eğitimi çocukların doğal ortamlarında hikâyeler, şarkılar, resimli kartlar, dramatizasyonlar, oyunlar ve hareketli aktivitelerle öğretilmektedir.
          </p>
          <div className="images-grid">
            {[q1, q2, q3, q4].map((src, idx) => (
              <img key={idx} src={src} alt={`Yabancı Dil ${idx + 1}`} />
            ))}
          </div>
        </div>


        <div className="atolye-section">
          <h2>Masal Atölyesi</h2>
          <p>
            Öğrencilerimizin dil, düşünme ve ifade becerilerini geliştirmek amacıyla Masal Atölyemiz açılmıştır.
            Bu atölyede dinleme, okuma, drama ve kendini ifade etme basamaklarını esas alarak çok yönlü bir öğrenme ortamı oluşturduk.
            Masallar, çocukların hayal dünyasını zenginleştiren, dil gelişimini destekleyen ve düşünsel yaratıcılıklarını
            harekete geçiren güçlü bir araçtır. Bu bağlamda masal atölyemizde; öğrencilerin dikkatli dinleme alışkanlıkları
            geliştirmesi, okuma sevgisi kazanması ve duygu düşüncelerini rahatlıkla ifade edebilmesi için çeşitli etkinliklere yer verilir.
            Drama uygulamalarıyla öğrencilerin yaratıcılıkları desteklenirken; grup çalışmalarında iş birliği, empati ve paylaşım
            becerileri pekiştirilir. Atölyemizde uyguladığımız bu bütüncül yaklaşım, hem öğrencilerimizin özgüvenini artırmış hem de
            sınıf içi iletişimi güçlendirmiştir. Masallarla kurulan bu sihirli öğrenme dünyasında çocuklarımız sadece dinlemekle kalmaz;
            düşünür, yorumlar, canlandırma ile kendilerini özgürce ifade ederler. Bu tür alternatif ve yaratıcı uygulamalar,
            çağdaş sınıf öğretmenliğinin temel yapı taşlarından biridir.
          </p>

          <div className="images-grid">
            {[ma1, ma2, ma3, ma4].map((src, idx) => (
              <img key={idx} src={src} alt={`Seramik ${idx + 1}`} />
            ))}
          </div>
        </div>

        {/* Resim Atölyesi */}
        <div className="atolye-section">
          <h2>Resim Atölyesi</h2>
          <p>
          Resim, çocuğun ruh ve beden gelişiminde dikkat çeken bir uygulama alanıdır. Resim yapmak, çocuğun gerçek dünya ile çocukça bakışın kurduğu iletişim göstergesidir. Çocuk, resim yaparak duygusal, algısal, gelişmeye yol bulur.
          Atölyemizde çok yönlü ve spontane bir eğitim söz konusudur. 
          Suluboya, pastel, karışık materyaller ile yapılacak çalışmaların aldığı süreçte çocuk, çevresinde gördüğü birçok ayrı nesneyi, anlamlı bir bütünlüğe dönüştürür.
          Bu seçme yorumlama yeniden biçimleme sürecinin sonunda ortaya çıkan ürün bir yapıt olmaktan çok çocuktan bir parçadır. Onun düşünüşü, onun duyuşu, onun görüşüdür.
          </p>
          <div className="images-grid">
            {[r1, r2, r3, r4, r5, r6].map((src, idx) => (
              <img key={idx} src={src} alt={`Resim ${idx + 1}`} />
            ))}
          </div>
        </div>

        {/* Müzik Atölyesi */}
        <div className="atolye-section">
          <h2>Müzik Atölyesi</h2>
          <p>
          Müzik bedenin ve zihnin birlikte çalışmasına yardımcı olur. Çocukları erken çocukluk döneminde çeşitli müziklerle tanıştırmak, kelimelerin seslerini ve anlamlarını öğrenmelerine yardımcı olur.
          Müzik atölyemizde öğrencilerimizin müzik yeteneğini ve müziksel algı ve bilgilerini geliştirmek, estetik sanat zevki oluşturmak amaçlanmaktadır.
          Müzik atölyemizde çeşitli enstrümanları tanıma ve kullanma imkânı bulan öğrencilerimiz;  müzik yoluyla duygu, düşünce ve deneyimlerini ifade etme imkânı bulmaktadırlar.
          </p>
          <div className="images-grid">
            {[m1, m2, m3, m4].map((src, idx) => (
              <img key={idx} src={src} alt={`Müzik ${idx + 1}`} />
            ))}
          </div>
        </div>

        {/* Spor Atölyesi */}
        <div className="atolye-section">
          <h2>Spor Atölyesi</h2>
          <p>
          Spor atölyemizde öğrencilerin fiziksel sağlığını desteklerken sosyal, duygusal ve zihinsel gelişimlerini de bütünsel bir şekilde desteklemekteyiz. 
           Çocukların enerjilerini doğru bir şekilde kullanmalarını sağlayarak özgüvenli ve mutlu bireyler olmalarına katkıda bulunmaktayız. Spor atölyesinde yaptığımız çalışma ve etkinlikler ile öğrencilerimizin motor becerileri ve koordinasyonu gelişmiş, takım çalışmasına uygun, liderlik ve iletişim becerisi yüksek, empati sahibi öğrenciler yetiştirmekteyiz.
          </p>
          <div className="images-grid">
            {[s1, s2, s3, s4, s5, s6].map((src, idx) => (
              <img key={idx} src={src} alt={`Spor ${idx + 1}`} />
            ))}
          </div>
        </div>



        {/* Dil Eğitimi Programı */}
        
      </section>
    </>
  );
}
